"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownSeparator = void 0;
/* eslint-disable  @typescript-eslint/no-explicit-any */

/** Возможность добавить скругления для первого или последнего фильтра в строке */

/** Пропсы для фильтров, обогащенные базовыми пропсами */

/**
 * Интерфейсы для базовых фильтров:
 *   * IFilterUI - фильтр-переключатель, подходит для группы кнопок
 * */

const dropdownSeparator = exports.dropdownSeparator = Symbol();